/**
 * Trigger browser download of an XLSX ArrayBuffer.
 * @param {ArrayBuffer} arrayBuffer
 * @param {string} filename
 */
export function triggerXlsxDownload(arrayBuffer, filename) {
	const blob = new Blob([arrayBuffer], {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	});
	const link = document.createElement("a");
	const url = URL.createObjectURL(blob);
	link.setAttribute("href", url);
	link.setAttribute("download", filename || "search_report.xlsx");
	link.style.visibility = "hidden";
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}

export function parseFilenameFromContentDisposition(contentDisposition) {
	if (!contentDisposition) return null;
	const match = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"|filename=([^;\s]+)/i.exec(
		contentDisposition,
	);
	const raw = match?.[1] || match?.[2] || match?.[3];
	if (!raw) return null;
	try {
		return decodeURIComponent(raw.replace(/"/g, ""));
	} catch {
		return raw.replace(/"/g, "");
	}
}
